
import { IHeaderConfig, INotificationsCount, IUserMenuConfig } from "@tools/CustomInterfaces";
import { IPageConfig } from "@extension/config/pagesConfig";

export interface IGlobalStateInit {
    user: any;
    currency: any;
    company: any|null;
    workplace: any|null;
    uploadUrl: string;
    token: string;
    userAgent: {isMobile: boolean},
    version?: string;
    sid: string;
    themeConfig : any,
    notifications: INotificationsCount[]
    sideBarCollapsed?: boolean|"none"
    socketEvents?: {[key: string] : any}
    pagesConfig : IPageConfig,
    pagesDecorator : any,
    hydraDirectory: string
    callInProgress?: any
    headerConfig? : IHeaderConfig
    userMenuConfig? : IUserMenuConfig
}

export interface IGlobalState extends IGlobalStateInit{
    initState: (data: any) => void
    updateThemeConfig: (data: any) => void
    createNotifications: (data: any) => void
    updateNotifications: (data: any) => void
    updateToken: (data: any) => void
    updateUser: (data: any) => void
    updateCallStatus: (data: any) => void
    updateCompany: (data: any) => void
    updateWorkplace: (data: any) => void
    collapseSidebar: (data: any) => void
    removeSocketEvents: (data: any) => void
    addSocketEvent: (data: any) => void
}

export const REDUCER = {
    SET_NEW_INITIAL_STATE : "SET_NEW_INITIAL_STATE",
    UPDATE_THEME_CONFIG : "UPDATE_THEME_CONFIG",
    CREATE_NOTIFICATIONS : "CREATE_NOTIFICATIONS",
    UPDATE_NOTIFICATIONS : "UPDATE_NOTIFICATIONS",
    UPDATE_TOKEN : "UPDATE_TOKEN",
    UPDATE_USER : "UPDATE_USER",
    UPDATE_COMPANY : "UPDATE_COMPANY",
    UPDATE_WORKPLACE : "UPDATE_WORKPLACE",
    UPDATE_CALL_STATUS : "UPDATE_CALL_STATUS",
    COLLAPSE_SIDEBAR: "COLLAPSE_SIDEBAR",
    ADD_SOCKET_EVENT: "ADD_SOCKET_EVENT",
    REMOVE_SOCKET_EVENTS: "REMOVE_SOCKET_EVENTS"
}
